import App from '../App.vue'
export default  {
    path: '/order',
    component: App,
    meta: { title: '订单' },
    children:[
        {
            path: 'new/:meetingID',
            component: () => import('../views/Order/New.vue'),
            meta: {
                title: '会议报名',
            }
        },
        {
            path: 'new-training/:meetingID',
            component: () => import('../views/Order/NewTraining.vue'),
            meta: {
                title: '培训班报名',
            }
        },
        {
            path: 'detail/:orderID',
            component: () => import('../views/Order/Detail.vue'),
            meta: {
                title: '订单详情',
            }
        },
        {
            path: 'detail/hotel/new/:orderID',
            component: () => import('../views/Order/HotelNew.vue'),
            meta: {
                title: '酒店预订',
            }
        },
        {
            path: 'detail/hotel/edit/:orderID',
            component: () => import('../views/Order/HotelEdit.vue'),
            meta: {
                title: '酒店编辑',
            }
        },
        {
            path: 'list/to_pay',
            component: () => import('../views/Order/ListToPay.vue'),
            meta: {
                title: '待支付订单列表',
            }
        },
        {
            path: 'list/paid',
            component: () => import('../views/Order/ListPaid.vue'),
            meta: {
                title: '已支付订单列表',
            }
        },
        {
            path: 'invoice/multiple-apply',
            component: () => import('../views/Order/MultipleInvoiceApply.vue'),
            meta: {
                title: '发票合并开取',
            }
        },
        {
            path: 'invoice/apply/:orderID',
            component: () => import('../views/Order/ApplyInvoice.vue'),
            meta: {
                title: '申请发票',
            }
        },
        {
            path: 'invoice/apply-multiple',
            component: () => import('../views/Order/ApplyInvoiceMultiple.vue'),
            meta: {
                title: '申请发票',
            }
        },
        {
            path: 'invoice/my-list',
            component: () => import('../views/Order/InvoiceList.vue'),
            meta: {
                title: '我的发票',
            }
        },
        {
            path: 'ticket/list',
            component: () => import('../views/Order/ListTicket.vue'),
            meta: {
                title: '会议门票列表',
            }
        },
        {
            path: 'ticket/detail/:ticketID',
            component: () => import('../views/Order/DetailTicket.vue'),
            meta: {
                title: '参会门票',
            }
        },
        {
            path: 'order-meeting-receipt/detail/:orderMeetingReceiptID',
            component: () => import('../views/Order/OrderMeetingReceipt.vue'),
            meta: {
                title: '回执单详情',
            }
        },
        {
            path: 'order-meeting-certificate/detail',
            component: () => import('../views/Order/OrderMeetingCertificate.vue'),
            meta: {
                title: '证书详情',
            }
        },
        {
            path: 'order-meeting-receipt/list',
            component: () => import('../views/Order/OrderMeetingReceiptList.vue'),
            meta: {
                title: '回执单管理',
            }
        },
    ]
}